<template>
  <div class="introduce-section" ref="sectionRef">
    <h1
      class="title"
      :class="{ 'animate-in': isVisible }"
      style="--animation-order: 1"
    >
      INTRODUCE
    </h1>
    <div class="content">
      <div
        class="image-wrapper"
        :class="{ 'animate-in': isVisible }"
        style="--animation-order: 2"
      >
        <img src="@/assets/imgsnew/tow/3-1.svg" alt="Cross-border payment" />
      </div>
      <div
        class="text-content"
        :class="{ 'animate-in': isVisible }"
        style="--animation-order: 3"
      >
        <h2 class="heading">CROSS-BORDER<br />NEW URBAN LIFE</h2>
        <p class="description">
          From meticulously planned privileges to the once-in-a-lifetime urban
          experiences, it brings distinctive changes to life. Here, you can find
          everything you need and embark on your very own priceless cross-border
          journey. Without a worry in the world, fully enjoy the boundless
          global cross-border experience
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const sectionRef = ref(null);
const isVisible = ref(false);
let observer = null;

const observerOptions = {
  threshold: 0.2,
  rootMargin: "0px",
};

const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      isVisible.value = true;
    } else {
      isVisible.value = false;
    }
  });
};

onMounted(() => {
  observer = new IntersectionObserver(handleIntersect, observerOptions);
  if (sectionRef.value) {
    observer.observe(sectionRef.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.introduce-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 80px 80px 120px;
  background-color: #fafbff;

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }

  .title {
    font-size: 32px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 60px;
    color: #000000;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: calc(var(--animation-order) * 0.1s);

    @media screen and (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 30px;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content {
    display: flex;
    gap: 80px;
    align-items: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 24px;
    }
  }

  .image-wrapper {
    flex: 1;
    overflow: hidden;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: calc(var(--animation-order) * 0.1s);

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 20px;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .text-content {
    flex: 1;
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: calc(var(--animation-order) * 0.1s);

    @media screen and (max-width: 768px) {
      text-align: center;
    }

    &.animate-in {
      opacity: 1;
      transform: translateY(0);
    }

    .heading {
      font-size: 32px;
      font-weight: 600;
      line-height: 1.2;
      margin: 0 0 24px;
      color: #000000;

      @media screen and (max-width: 768px) {
        font-size: 24px;
        margin: 0 0 16px;
      }
    }

    .description {
      font-size: 16px;
      line-height: 1.6;
      color: #666666;
      margin: 0;

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }
  }
}
</style>
